<template>
    <span></span>
</template>

<script>
import api from '@/services/api';
import redirect from '@/services/redirect';

export default {
  name: 'LoginExt',
    

  data() {
    return {
      accessConfig: { passwordUsed: false },
      revalidateUser: false, 
      previousRoute: {}
    };
  },

  methods: {
    redirectAfterLogin(response) {
      // if ((response.data.firstLogin && this.accessConfig.userProfileOnFirstLogin) || this.accessConfig.userProfileAlways) {
      //   if (this.accessConfig.userProfileRegister) {
      //     this.$router
      //       .push({
      //         name: 'UserProfileRegister',
      //         params: {
      //           firstLogin: response.data.firstLogin,
      //           email: response.data.email,
      //         },
      //       })
      //       .catch(err => {
      //         console.log('navigation error', err);
      //         alert(this.accessConfig.loginView.failMessage ? this.accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações');
      //       });
      //   } else {
      //     this.$router
      //       .push({
      //         name: 'UserProfile',
      //         params: {
      //           firstLogin: response.data.firstLogin,
      //           email: response.data.email,
      //         },
      //       })
      //       .catch(err => {
      //         console.log('navigation error', err);
      //         alert(this.accessConfig.loginView.failMessage ? this.accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações');
      //       });
      //   }
      if ((response.data.firstLogin && (this.accessConfig.userProfileOnFirstLogin || this.accessConfig.altFirstLogin)) || this.accessConfig.userProfileAlways) {
        if (this.accessConfig.altFirstLogin){
          this.$router
            .push({
              name: this.accessConfig.firstPageAlt,
              params: this.accessConfig.firstPageParamsAlt ?? null,
  
            })
            .catch(err => {
              console.error('navigation error', err);
              modal.show('dialog', {
                title: '',
                text: this.accessConfig.loginView.failMessage ? this.accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações',
                buttons: [
                  {
                    title: 'Ok',
                    handler: () => {
                    modal.hide('dialog');
                  },
                },
              ],
            });
          });
        }else if (this.accessConfig.userProfileRegister) {
          this.$router
            .push({
              name: 'UserProfileRegister',
              params: {
                firstLogin: response.data.firstLogin,
                email: response.data.email,
              },
            })
            .catch(err => {
              console.error('navigation error', err);
              modal.show('dialog', {
                title: '',
                text: this.accessConfig.loginView.failMessage ? this.accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações',
                buttons: [
                  {
                    title: 'Ok',
                    handler: () => {
                      modal.hide('dialog');
                    },
                  },
                ],
              });
            });
        } else {
          this.$router
            .push({
              name: 'UserProfile',
              params: {
                firstLogin: response.data.firstLogin,
                email: response.data.email,
              },
            })
            .catch(err => {
              console.error('navigation error', err);
              modal.show('dialog', {
                title: '',
                text: this.accessConfig.loginView.failMessage ? this.accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações',
                buttons: [
                  {
                    title: 'Ok',
                    handler: () => {
                      modal.hide('dialog');
                    },
                  },
                ],
              });
            });
        }
        this.$emit('close');
      } else {
        if (this.revalidateUser) {
          // console.log('ENTER revalidateUser and push logic: ', this.previousRoute.name);
          this.accessConfig.firstPage = this.previousRoute.name;
          this.accessConfig.firstPageParams = this.previousRoute.params;
        }
        this.$router
          .push({
            name: this.accessConfig.firstPage,
            params: this.accessConfig.firstPageParams ?? null,
          })
          .catch(err => {
            console.log('navigation error', err);
            alert(this.accessConfig.loginView.failMessage ? this.accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações');
          });
        this.$emit('close');
      }
    },
    loginExt() {
      //console.log('Analisando login');
      const { user } = this.$route.query;
      try {
        const userParse = JSON.parse(user);
        //console.log('Parse', userParse);
        const email = userParse.access_code;
        //console.log('EMail', email);
        const token = userParse.token;
        //console.log('Token', token);
        api
          .post(`event/${this.$store.state.eventId}/google/login`, { email: email, token: token })
          .then(response => {
            // console.log('Login RESPONSE', { response });
            this.$store.commit({
              type: 'setUser',
              userData: response.data,
            });
            // api
            //   .post(`event/${this.$store.state.eventId}/commetChat`, { user_id: this.$store.state.user.id })
            //   .then((res) => {
            //     // console.log('getchatuser', res);
            //   })
            //   .catch((chatError) => {
            //     console.log('getchatuser error', chatError);
            //   });

            //this.redirectAfterLogin(response);
            redirect.redirectAfterLogin(response, this.revalidateUser, this.previousRoute, this.$modal);
          })
          .catch((err, data) => {
            console.log('error', err.response, data);
            this.$router
              .push({
                name: 'Home',
              })
              .catch(err => {
                console.log('navigation error', err);
                alert(this.accessConfig.loginView.failMessage ? this.accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações');
              });
          });
      } catch (err) {
        console.log(err);
        this.$router
          .push({
            name: 'Home',
          })
          .catch(err => {
            console.log('navigation error', err);
            alert(this.accessConfig.loginView.failMessage ? this.accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações');
          });
      }
    },
  },

  mounted() {
    //console.log('Montado! ', this.$route.query);
    try{
      const loginGoogleRevalidate = JSON.parse(localStorage.getItem('loginGoogleRevalidate'));
      if (loginGoogleRevalidate) {
        console.log('Salvo no storage', loginGoogleRevalidate);
        this.revalidateUser = loginGoogleRevalidate.revalidateUser;
        this.previousRoute = loginGoogleRevalidate.previousRoute;
        console.log('loginGoogleInfo:',this.revalidateUser, this.previousRoute, this.$store.state )
      }
    }catch(err){
      console.log(err);
    }
    
    
    this.loginExt();
  },
  beforeMount() {
    this.accessConfig = this.$store.state.template.accessConfig;
  },
};
</script>